export const menu = ['products', 'solutions', 'contact', 'translators'];
